module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmh"
  }, [_c('a', {
    attrs: {
      "id": "page_xix"
    }
  }), _vm._v("Translator’s Note")]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The Army gives orders and so does the Armee. To avoid confusion I have translated the word ‘Heer’ meaning Army in the sense of Army, Navy and Air Force as ‘Army’. I have left untranslated the German word ‘Armee’, for example 6 Armee, 17 Armee, to distinguish the subsidiary Armee units which made up the whole.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ranks of officer in the Abteilung and brigade ran Leutnant, Oberleutnant, Hauptmann, Major etc. as per the standard Army practice. The ‘other ranks’ started off as ‘Kanonier’ (gunner recruit), ‘Funker’ (wireless operator recruit) and so forth. ‘Gefreiter’ was a trained Private, usually with a few years’ service. Obergefreiter, the next rank up, was a senior Private or ‘Lance Corporal’ with some powers of command but no status as an NCO.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The lowest rank of NCO was Unteroffizier (Corporal) but a man had to go through a training course as such before being appointed one.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Probably to reflect the cavalry role taken over by the StuG panzer in mutual support of infantry, the sergeants were given cavalry ranks: Wachtmeister (sergeant), Oberwachtmeister (senior sergeant) and Hauptwachtmeister (sergeant major), equivalent to a First Warrant Officer or Second Warrant Officer. An NCO had to be saluted but the extent to which this was necessary is not certain.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ‘Tross’ supported the fighting staff with its immediate needs in ammunition, provisions and combat supplies. The author, Bruno Bork, was for some time the Hauptwachtmeister in charge of the Tross at Abteilung 191 but when the need arose he commanded an StuG and was eventually seriously wounded in battle.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xx"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f00xx-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The typical StuG of the early war years with the 7.5-cm L/24 ‘stump cannon’.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f00xx-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("After the bitter experiences in the Russian campaign, the StuG of the later war years was equipped with the 7.5-cm L/48 long barrel.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xxi-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hermann Röhm was a member of 9 StuG Artillerie-Lehrregiment 2 (mot.) at Jüterbog.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xxi-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hermann Röhm in ‘normal’ Army uniform with puttees.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xxi-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The military career of Hermann Röhm until 9 December 1941 as set out in a field postcard. He supplied this book with many interesting photographs from Jüterbog and StuG Abteilung 191 from 1942 to 1944. His text "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("My Time as a Recruit from 2 Oct 1941")]), _vm._v(" reads: ‘I had to report to Essling (Vienna) on 2 Oct. 1941. From 2 to 6 Oct. infantry training at Ludwigsburg (Baden-Württemberg) with the [illegible] artillery. 7 and 8 Oct. transferred to Epinal (Vosges, France) with heavy artillery Ersatz Abt. 61, mot. Training as a Wehrmacht driver from 9 Oct. until 1 Dec. 1941. From 2 to 6 Dec. by train to Jüterbog, Berlin. On 8 Dec drafted to Sturmartillerie. 15/12 took over vehicle and service with Sturmartillerie. Following pictures show my subsequent life as a soldier.’")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Song of the Sturmartillerie.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxii-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hermann Röhm in black StuG blouse. The uniform of the StuG Abteilungen resembled that of the Panzer Arm but the collar patches lacked the death’s head symbol.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxii-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The barracks of 9/StuG Artillerie-Lehrregiment 2 (mot.), Adolf Hitler Lager, Jüterbog, south of Berlin.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxiii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Christmas festivities in December 1941 with a circle of comrades. At the same time on the Eastern Front, the German armies were suffering heavy losses as their advance faltered for the first time.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxiii-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The richly spread table of presents, Christmas 1941. The tree is splendidly adorned with silver tinsel.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxiii-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The Leutnant with his soldiers. He wears the ribbon of the Iron Cross II, and therefore has already had experience at the front.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxiv"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxiv-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A finely painted shield on the barracks wall. The StuG had long since matured into a branch of the artillery.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxiv-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The soldiers’ cinema in the Adolf Hitler Lager at Jüterbog.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxiv-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("In the harsh winter of 1941 everything at Jüterbog was heavily blanketed with snow, as the outdoor swimming pool is here.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxv"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xxv-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Supply lorries neatly lined up before the halls.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xxv-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("To spare wear and tear on the StuG tracks during road travel, the special trailer (Sonderanhänger 116) of 22-tonne carrying capacity was used. The rear pair of wheels could be steered. The driver sat in the open air or within a removable cabin.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvi"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxvi-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A Skoda Praga Type 6 towing machine snowed in at the barracks.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxvi-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hermann Röhm in battle dress by a training StuG.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxvi-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A whole row of StuGs (C and D versions) alongside the halls.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxvii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxvii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The most frequently deployed StuG of the war years 1940 to 1942 was armed with the 7.5-cm short-barrel L/24 cannon.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxvii-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hermann Röhm (second from left) with colleagues in the squad room.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxviii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxviii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Spring 1942, leaving on manoeuvres, the motorcycle rider included.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxviii-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A command/observation vehicle built especially for the StuG Arm was the Sd.Kfz 253, developed on the chassis of the light Sd.Kfz 250 (armoured infantry-carrier). In action the vehicle proved too lightly armoured.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxviii-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("In this photo is an StuG, a light ammunition transporter Sd.Kfz 252 and a Magirus lorry of the Lehrkompanie. On all vehicles, ‘L’ signified ‘training’ (‘Lehrkompanie’).")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxix"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxix-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("(above) A pause during training and (below) fooling around for the camera.")]), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxix-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxx"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xxx-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hermann Röhm in the armoured ammunition vehicle Sd.Kfz 250/6. The motor is running and blows the exhaust out laterally.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xxx-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("February 1942: battle training in the extensive pine woods of Mark Brandenburg.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xxx-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The plan included infantry training. Here, a light machine-gun team with the MG 34.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxi"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxi-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("End of the exercise! The StuGs, ammunition vehicles and lorries arrive back at barracks.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxi-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Comrades of the motorcycle units and workshop platoon.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("StuG version F with muzzle cap on the stump barrel.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxii-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The 7.5-cm short-barrel muzzle of a StuG.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxii-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Steel helmets loose on the gun. They had to be carried but were very cumbersome in action.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxiii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxiii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The despatch rider has on the sidecar of his BMW R12 the ‘L’ indicating ‘Lehrkompanie’.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxiii-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hermann Röhm on sentry duty at one of the many outer gates of the Adolf Hitler Lager, Jüterbog.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxiii-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The two-part barrel cleaner for the 7.5-cm barrel is located here above the track guard.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxiv"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxiv-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("During the very harsh winter of 1941 snowdrifts cut off surrounding villages and StuGs were detailed to assist. Before departure the map is studied to pinpoint the precise locations.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxiv-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The journey involves crossing country lying under deep snow in order to reach farmsteads cut off from the outside world.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxiv-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Sentry duty during the bitterly cold winter of 1941 was not enjoyable.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxv"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxv-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A training StuG ‘L’ with identification letter ‘B’.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxv-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hermann Röhm on StuG ‘B’. The chassis number is very difficult to make out.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxv-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("March 1942: StuGs parked in the halls.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxvi"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxvi-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A robust 8-tonne towing machine Sd.Kfz 7 in the terrain. These tugs were widely used by the Wehrmacht and were often the last recourse in thick mud.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxvi-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A group photo by the towing machine. Hermann Röhm is indicated by an ‘X’.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxvii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxvii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("During the long winter evenings of 1941/42 men of the StuG Lehrkompanie worked on an StuG model, made from metal parts, complete with ‘garage’.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxvii-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The garage with ‘smoking forbidden’ notice on the door.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxvii-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The StuG model demonstrates its power ‘in the terrain’.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxviii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxviii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The size of the model in comparison with its builder.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxviii-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hermann Röhm in black field blouse, tie and steel helmet.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxviii-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The track members were made of wire. It was a fine piece of work, the fate of which is unfortunately not known.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xxxix"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxix-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("In the spring of 1942, damaged vehicles from StuG Abteilung 191 returned to Jüterbog from the Eastern Front. In the photo is a command/observation half-track Sd.Kfz 253.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxxxix-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hermann Röhm with the unloading crew. In the photo is command vehicle No. 21. Because of bad experiences with these command vehicles in action, from 1942/43 the leaders of each StuG Abteilung were allocated their own StuG with expanded radio equipment.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xl"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f00xl-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A light armoured command vehicle Sd.Kfz 253, apparently with motor damage, being pulled by a truck. StuG Abteilung 191 was at Mogilev for a refresher course from April to May 1942. Still usable vehicles were no longer sent back to Germany.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f00xl-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The engine compartment of this vehicle was destroyed by fire. All reusable parts had already been removed by the Abteilung in Russia.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xli"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xli-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hermann Röhm on the 18-tonne Famo towing machine (Sd.Kfz 9), the most powerful tug available to the Wehrmacht.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xli-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Even the frontal plating has been removed from this gutted observation vehicle.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xli-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The removal of a ‘tin can’ like this one was no problem for the Famo.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xlii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxlii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Heinz Bethge and Hans Büsing.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxlii-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("All wear the black panzer uniform but with field-grey field cap. The collar patches have (artillery) red edging (not pink as the Panzer Arm had).")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxlii-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A pose in the Jüterbog barracks.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xliii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxliii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Competitors in front of an inn, the ‘Berliner Schlossbräu’.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxliii-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A queue of vehicles on a cobbled street in the camp, June 1942. The Artillerie-Lehrabteilung carried out demonstrations for foreign visitors.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxliii-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Group photo at the lorry park.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xliv"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxliv-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("At the Artillerie-Lehrabteilung, Jüterbog, ‘secret weapons’ were tested, here one of two self-propelled gun carriages with the powerful 10.5-cm K 18 cannon.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxliv-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A powerful leap in development from the 7.5-cm stump cannon to this giant gun.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxliv-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The two cannons were mounted respectively on a converted Panzer Mark IV frame and box chassis. Both prototypes were tested in 1942 by 3 Panzer Division in the East, where they were found to be too heavy and lacking mobility in action.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xlv"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xlv-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Forty winks near a light ammunition panzerwagen Sd.Kfz 250/6. A steel helmet is hung up on the MG 34.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xlv-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hermann Röhm in regular field-grey StuG uniform which had the same style as the Panzertruppe issue.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0xlv-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Command personnel play a hand of skat near the barracks entrance, identities unfortunately no longer known.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xlvi"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxlvi-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("An interesting view through the rear loading hatch into the interior of an armoured ammunition-carrier. The driver’s seat is to the left, the radio operator’s to the right. In the foreground are the closed flaps of the ammunition container. These vehicles could tow a trailer.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxlvi-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("View into the engine compartment of an armoured ammunition-carrier. Two oil caps can be seen on the cylinder head cover.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xlvii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxlvii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Opened ammunition trailer (Sd.AnH 32A) with 7.5-cm HE shell 34. Sixty-four shells were carried in two chambers. A light armoured ammunition-carrier Sd. Kfz 252 could transport about 150 rounds.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxlvii-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The driver of a Kfz 15 Staff car. There is a good view of the instrument panel.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xlviii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxlviii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hermann Röhm standing by an armoured ammunition-carrier (Sd.Kfz 252).")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxlviii-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Wehrmacht Army registration plate and ‘L’ for Lehrabteilung clearly seen here.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxlviii-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Manoeuvres in the sand of Mark Brandenburg close to a ruined bunker, end of May 1942.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_xlix"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxlix-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A comrade of the service team with screwdriver.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxlix-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Apparently little enthusiasm for maintenance.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/fxlix-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("A view over the boiler mounted on the field-kitchen lorry.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_l"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f000l-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The 3-tonne Magirus Klöckner Deutz lorry with which the Lehrabteilung was uniformly equipped.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f000l-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("These reliable lorries were produced between 1941 and 1943.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f000l-3.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Time for a quick smoke by a lorry. On its roof is a triangular reflector.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_li"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f00li-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("View of the driving position of an StuG with open driver’s shield. The driver is holding the left steering lever which works on the steering brake. To the right of the picture is the crank to elevate the cannon.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f00li-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Close-up of an StuG’s 7.5-cm L/24 stump cannon. From mid-1942 StuGs at the front were fitted with the long-barrel L/48 which increased firepower sufficiently to engage the Russian T-34 tank.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_lii"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0lii-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("Hermann Röhm shortly before leaving Jüterbog.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0lii-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("The last evenings in a warm bed. From 21 December 1942 the company loaded up and moved out for Russia.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0lii-3.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c44478f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Translator.vue
// module id = 78
// module chunks = 0